import type { ButtonHTMLAttributes } from 'react';

/**
 * Botão de envio dos formulários — o **mesmo** `.cta` do sistema visual, em
 * largura cheia. Sem estilo próprio, como no `enamed-feedback-lp`: dois botões
 * primários no app é o começo de duas aparências diferentes.
 */
export function Button({
  className = '',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button className={`cta cta-inline cta-block ${className}`} {...props} />
  );
}
